import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component, VNode } from 'intact-vue-next';
import template from './item.vdt';
import { useConfigContext } from '../config';
var typeDefs = {
  label: [String, Number, VNode],
  content: [String, Number, VNode],
  append: [String, Number, VNode]
};
export var DescriptionItem = /*#__PURE__*/function (_Component) {
  _inheritsLoose(DescriptionItem, _Component);
  function DescriptionItem() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.config = useConfigContext();
    return _this;
  }
  return DescriptionItem;
}(Component);
DescriptionItem.template = template;
DescriptionItem.typeDefs = typeDefs;